// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__ZFreA","title":"ClientReferral_title__3gp9E","itemText":"ClientReferral_itemText__1aqwr"};